// Circles variables
// Drupal implementation - core/underscore needs to be added to libraries.yml for _ variable
function throttle(func, timeFrame) {
  let lastTime = 0;
  return function (...args) {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}

const circles = document.querySelectorAll('.circles');

// Set circlesParallax
function circlesParallax() {
  for (let i = 0; i < circles.length; i++) {
    const scrollingDistance = window.scrollY;
    /* global motionQuery */
    if (!motionQuery || motionQuery.matches) {
      // Disable circles parallax if `prefers-reduced-motion`
      circles[i].style.transform = '';
    } else {
      circles[i].style.transform = `translateY(-${scrollingDistance * 0.15}px)`;
    }
  }
}

window.addEventListener("load", () => {
    if (circles) {
    // Throttle scroll behavior
    window.addEventListener('scroll', throttle(circlesParallax, 50));
  }
});
